import { ChangeEvent, useEffect } from 'react'
import { Badge, HStack, Input, Stack } from '@chakra-ui/react'

import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import validateTextOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validateTextOnCustomForm'
import useCustomFormGetDefaultValue from '../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormTextQuestion({
  question,
  questionKey,
  formMethods,
  disabled,
}: CustomFormViewerQuestionProps) {
  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  const questionWithError = thisQuestionHasError(question.slug)?.question

  function validateTextQuestion(text: string) {
    const errorMessage = validateTextOnCustomForm({ text, question })
    if (errorMessage === '') {
      removeErrorFromQuestion(question.slug)
      if (formMethods?.setValue) {
        formMethods.setValue(questionKey, text)
      }
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  function handleOnBlur(event: ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value
    validateTextQuestion(inputValue)
  }

  useEffect(() => {
    if (defaultValue) {
      validateTextQuestion(defaultValue)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <Input
        id={question.slug}
        isDisabled={disabled}
        placeholder={question?.placeholder}
        value={formMethods?.watch ? formMethods.watch(questionKey) : defaultValue}
        {...(formMethods?.register && formMethods.register(questionKey, { onBlur: handleOnBlur }))}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />

      {question.validation && (
        <HStack>
          {question.validation.max && <Badge textTransform="none">Caractéres máximo ({question.validation.max})</Badge>}
        </HStack>
      )}
    </Stack>
  )
}
